export default {
  onEventChange(event) {
    if (
      typeof event.get('team') === 'string' &&
      typeof event.get('_id') === 'string'
    ) {
      this._teamId = event.get('team');
      this._eventId = event.get('_id');
    } else {
      const stackTrace = new Error().stack;
      console.error(
        'EventChangeListenerMixin: invalid event format',
        stackTrace,
      );
    }
  },
};
